interface Cf7SubmissionEvent {
    event: string;
    formId: string;
    response: any;
}

interface DetailInterface {
    contactFormId: number;
    contactFormLocale: string;
    containerPostId: BigInt;
    formData: FormData;
    inputs: any[];
    pluginVersion: string;
    status: string;
    unitTag: string;
    apiResponse: ApiResponseInterface;
}

interface ApiResponseInterface {
    contact_form_id: BigInt;
    into: string;
    invalid_fields: any[];
    message: string;
    posted_data_hash: string;
    status: string;
}

export default class ContactFormConversion {
    public async init() {
        document.addEventListener("wpcf7mailsent", function (e: Event) {
            const custom_event = e as CustomEvent<DetailInterface>;

            const cf7Event = {
                event: "cf7submission",
                formId: custom_event.detail.contactFormId.toString(),
                response: custom_event.detail.inputs,
            } as any;

            window.dataLayer.push(cf7Event);
            console.log(window.dataLayer);
        });
    }
}
